'use strict';

/**
 * Company-defined custom slots:
 * - Legacy CustomTempSection slots: UD001–UD005
 * - User-added TempSection custom slots: UD021–UD025 (createCustomSection)
 * - Older CS… prefix rows from addCustomTempSection
 *
 * Used to bypass advisor/investor/member section gates for sidebar visibility and saves.
 *
 * @param {string|null|undefined} sectionNoOrQNo  Section number or full question qNo
 * @returns {boolean}
 */
export function isCustomTempSectionNo(sectionNoOrQNo) {
    if (sectionNoOrQNo == null || sectionNoOrQNo === '') return false;
    const root = String(sectionNoOrQNo).split('.')[0].trim();
    if (!root) return false;
    // Reason: createCustomSection assigns UD021–UD025; older flows used UD001–UD005 / CS…
    if (/^UD00[1-5]$/i.test(root)) return true;
    if (/^UD02[1-5]$/i.test(root)) return true;
    if (/^CS[A-Z0-9]+$/i.test(root)) return true;
    return false;
}
